import { useEffect, useRef } from 'react';
import { APIGetChatMessagesSince } from '../api';

export function useChatCatchUp({ chatId, token, ready, messages, setMessages, connected = true }) {
  const current = useRef({ messages, setMessages }); current.current = { messages, setMessages };
  const wakeRef = useRef(() => {});
  useEffect(() => {
    if (connected) wakeRef.current();
  }, [connected]);
  useEffect(() => {
    if (!ready || !chatId || !token) return undefined;
    let cancelled = false, busy = false, dirty = false, timer = null;
    let cursor = Math.max(0, ...current.current.messages.map(m => Number(m.id) || 0));
    const catchUp = async () => {
      if (cancelled || document.visibilityState !== 'visible') return;
      dirty = true;
      if (busy) return;
      busy = true;
      try {
        while (dirty && !cancelled) {
          dirty = false;
          let more = true, pages = 0;
          while (more && !cancelled && pages++ < 10) {
            const data = await APIGetChatMessagesSince(chatId, token, cursor);
            if (cancelled) return;
            const next = Number(data.next_after_id);
            if (!Number.isFinite(next) || next < cursor || (data.has_more && next === cursor)) {
              throw new Error('Неверный курсор догрузки');
            }
            current.current.setMessages(prev => [...prev, ...(data.messages || [])]);
            cursor = next; more = !!data.has_more;
          }
          if (more && !cancelled) {
            timer = setTimeout(catchUp, 200);
            break;
          }
        }
      } catch (error) { if (!cancelled) console.error('Догрузка чата не выполнена', error); }
      finally { busy = false; }
    };
    wakeRef.current = catchUp;
    const wake = () => catchUp();
    window.addEventListener('focus', wake); window.addEventListener('online', wake);
    window.addEventListener('planium:unread-synced', wake);
    document.addEventListener('visibilitychange', wake);
    const poll = setInterval(catchUp, 45000);
    catchUp();
    return () => {
      cancelled = true; clearTimeout(timer); clearInterval(poll); wakeRef.current = () => {};
      window.removeEventListener('focus', wake); window.removeEventListener('online', wake);
      window.removeEventListener('planium:unread-synced', wake);
      document.removeEventListener('visibilitychange', wake);
    };
  }, [chatId, token, ready]);
}